/**
 * Same pattern as sticky-atc-panel: show the theme spinner as soon as
 * the main APO / Mulberry ATC is pressed.
 */
(function () {
  'use strict';

  var SELECTOR = '.mw-apo-add-to-cart-custom, .mulberry-custom-atc';

  function clear() {
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(SELECTOR);
      if (!btn || !e.isTrusted || btn.disabled) return;
      if (btn.classList.contains('mw-apo-atc-guard--blocked')) return;

      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
    },
    true
  );

  document.addEventListener('on:cart:add', clear);
  document.addEventListener('on:cart:error', clear);
})();
